import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-shutterstock',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Shutterstock icon</title><path d="M9.839 18.761h5.313a1.53 1.53 0 0 0 1.527-1.528v-5.76h5.237v5.76A6.767 6.767 0 0 1 15.152 24H9.839v-5.239M14.16 5.237H8.85a1.53 1.53 0 0 0-1.53 1.527v5.761H2.085V6.764A6.763 6.763 0 0 1 8.85 0h5.31v5.237Z"/></svg>`,
    styles: []
})
export class SimpleIconsShutterstockComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#EE2B24';
    @Input() className: string = 'simple-icons-shutterstock'
    constructor() {}
    ngOnInit(): void {}
}
